import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { Acquisition } from "models/acquisition-import";
import { useAuth } from "src/contexts/AuthContext";

export const useAcquisitions = () => {
  const [acquisitions, setAcquisitions] = useState<Acquisition[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchAcquisitions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(`${API_URL}/acquisition-imports`, {
        method: "GET",
      });
      const data = await checkResponse(response);
      setAcquisitions(data.items || []);
    } catch (err) {
      console.error("Error fetching acquisitions:", err);
      setError("Failed to fetch acquisitions.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAcquisitions();
  }, []);

  return { acquisitions, loading, error, refetch: fetchAcquisitions };
};
